// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Calculate/styles.scss
// module id = 1262
// module chunks = 0